import type { ComponentType } from "react";
import type { IconProps } from "@tabler/icons-react";
import { EmptyState } from "../../../../components/common/empty-state";

export function EmptyRow({ icon, title }: { icon: ComponentType<IconProps>; title: string }) {
  return <EmptyState icon={icon} title={title} className="!py-4" />;
}
